/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 09:44:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-09 16:51:06
 * @name: 通讯录模块控制器
 * @Description: 通讯录模块控制器
 * @FilePath: \project\src\module\department\department.controller.js
 * @Author: desktop
 */
import { Controller, Get, Post, Validator } from "@/nestVue/common";
@Controller('department')
class departmentController {
  constructor() {

  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 列表
   */
  @Get('getList.html')
  getList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 搜索
   */
  @Validator(require('./validator/search').validator, { toastError: true })
  @Get('search.html')
  search(ctx) { }
  /**
  * @Auther: 罗耀祖
  * @LastEditors: 罗耀祖
  * @description: 个人资料
  */
  @Validator(require('./validator/getDetail').validator)
  @Get('getDetail.html')
  getDetail(ctx) { }
  /**
  * @Auther: 罗耀祖
  * @LastEditors: 罗耀祖
  * @description: 人员信息
  */
  @Get('user/detail.html')
  userDetail(ctx) { }
}
export default departmentController;